/**
 * This module contains APIs related to a Transition.
 *
 * See [[Transition]], [[$transitions]]
 *
 * @module transition
 * @preferred
 */
/** for typedoc */
export * from "./interface";
export * from "./hookBuilder";
export * from "./hookRegistry";
export * from "./rejectFactory";
export * from "./transition";
export * from "./transitionHook";
export * from "./transitionService";




/** WEBPACK FOOTER **
 ** ./transition/module.ts
 **/